export default __webpack_public_path__ + "static/media/manicurehybrydowypo.e582c914.jpeg";